export const	CATEGORY= "category";
export const	PRODUCT= "product";
export const	STORE= "store";